export const TOKEN_KEY = 'smc-token'
export const SIDEBAR_COLLAPSED_KEY = 'smc-sidebar-collapsed'
export const THEME_KEY = 'smc-theme'
export const MEDIA_KEY = 'smc-media'
